import { SettingsRoutes } from 'pages/settings/route/type'
import { WidgetChatRoutes } from 'pages/settings/pages/widgetChat/route/type'

const root = `/${SettingsRoutes.root}/${WidgetChatRoutes.root}`

export const WidgetChatPath = {
  root,
}
